import { defaultPagination } from 'shared/constants';

export const calculateAfterPagination = (
  currentPage: number,
  rowsPerPage: number = defaultPagination.rowsPerPage
): string | null => {
  const afterNumber = currentPage * rowsPerPage - 1;
  return afterNumber <= 0 ? null : afterNumber.toString();
};
